import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

type P = {
  tabComponent?: ReactNode;
  children?: ReactNode;
};

const LeftContainer = ({ tabComponent, children }: P) => {
  return (
    <Box sx={{ p: '0px 24px 24px 30px' }}>
      {tabComponent}
      {children}
    </Box>
  );
};
export default LeftContainer;
